export default function HalfRow({ children }) {
  return <div className="col-span-6 sm:col-span-3">{children}</div>;
}
